import React from 'react';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import IconSection from '../../../@communityshare/ui/card/IconSection';

export default function Active(props) {
  const { site } = props;

  if (site.data.isActive) {
    return (
      <IconSection
        icon={CheckIcon}
        tooltip="Is Active"
        title="Active"
        color="text-cs-green-500"
      />
    );
  }

  return (
    <IconSection
      icon={XMarkIcon}
      tooltip="Is Active"
      title="Inactive"
    />
  );
}
